module.exports = __webpack_public_path__ + "media/images/slider-arrows-f1e51c30.png";